// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1tDlu","title":"Info_title__1H2fC","links":"Info_links__2kTGo","link":"Info_link__2Ktsg","logo":"Info_logo__1PnpP"};